<template>
    <div>
        <div class="sub_title" @click="contentShow = !contentShow">
            표시설정
            <i class="el-icon-arrow-down" v-show="!contentShow"></i>
            <i class="el-icon-arrow-up" v-show="contentShow"></i>
        </div>
        <el-collapse-transition>
            <div class="c_table_wrap" v-show="contentShow">
                <table>
                    <colgroup>
                        <col width="200px;">
                        <col width="">
                    </colgroup>
                    <tr>
                        <td class="c_t_title">진열상태</td>
                        <td>
                            <div>
                                <el-radio-group v-model="display" @change="parentChange('display', display)">
                                    <el-radio :label="1" value="1">진열함</el-radio>
                                    <el-radio :label="0" value="0">진열안함</el-radio>
                                </el-radio-group>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">판매상태</td>
                        <td>
                            <div>
                                <el-radio-group v-model="selling" @change="parentChange('selling', selling)">
                                    <el-radio :label="1" value="1">판매함</el-radio>
                                    <el-radio :label="0" value="0">판매안함</el-radio>
                                </el-radio-group>
                            </div>
                        </td>
                    </tr>
<!--                    <tr>
                        <td class="c_t_title">스마트 피팅</td>
                        <td>
                            <div>
                                <el-radio-group v-model="fitting" @change="parentChange('fitting', fitting)">
                                    <el-radio :label="1" value="1">제공</el-radio>
                                    <el-radio :label="0" value="0">미제공</el-radio>
                                </el-radio-group>
                            </div>
                        </td>
                    </tr>-->
                    <tr>
                        <td class="c_t_title">상품 분류</td>
                        <td>
                            <div class="product_category_wrap">
                                <div v-html="getCateValue()" class="product_select_category"></div>
                                <el-row>
                                    <el-col :span="6">
                                        <div class="tab_title text_center">
                                            대분류
                                        </div>
                                        <div class="tab_wrap h300">
                                            <div class="tab_name" v-for="(item, index) in SelCateList[0]" :key="`depth1-${index}`" @click="SetSubCate(1, item)">
                                                <span>{{item.NAME}}</span>
                                                <i v-if="item.hasOwnProperty('child')" class="el-icon-arrow-right"></i>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="tab_title text_center">
                                            중분류
                                        </div>
                                        <div class="tab_wrap h300">
                                            <div class="tab_name" v-for="(item, index) in SelCateList[1]" :key="`depth2-${index}`">
                                                <span @click="SetSubCate(2, item)">{{item.NAME}}</span>
                                                <i v-if="item.hasOwnProperty('child')" class="el-icon-arrow-right"></i>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="tab_title text_center">
                                            소분류
                                        </div>
                                        <div class="tab_wrap">
                                            <div class="tab_name" v-for="(item, index) in SelCateList[2]" :key="`depth3-${index}`">
                                                <span @click="SetSubCate(3, item)">{{item.NAME}}</span>
                                                <i v-if="item.hasOwnProperty('child')" class="el-icon-arrow-right"></i>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="tab_title text_center">
                                            상세분류
                                        </div>
                                        <div class="tab_wrap h300">
                                            <div class="tab_name" v-for="(item, index) in SelCateList[3]" :key="`depth4-${index}`">
                                                <span @click="SetSubCate(4, item)">{{item.NAME}}</span>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                                <div class="input_error">{{validation.firstError('category') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">세부 설정</td>
                        <td>
                            <div class="d_block">
                                <el-select v-model="pattern" class="mr10" placeholder="패턴"  @change="parentChange('pattern', pattern)">
                                    <el-option
                                        v-for="(item, index) in PatternList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="season" class="mr10" placeholder="시즌" @change="parentChange('season', season)">
                                    <el-option
                                        v-for="item in SeasonList"
                                        :key="`season${item.value}`"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="color" class="mr10" placeholder="컬러" @change="parentChange('color', color)">
                                    <el-option
                                        v-for="item in ColorList"
                                        :key="`color${item.value}`"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="tone" class="mr10" placeholder="톤" @change="parentChange('tone', tone)">
                                    <el-option
                                        v-for="item in ToneList"
                                        :key="`tone${item.value}`"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="gender" class="mr10" placeholder="성별" @change="parentChange('gender', gender)">
                                    <el-option
                                        v-for="item in GenderList"
                                        :key="`gender${item.value}`"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <el-select v-model="bottomType" class="mr10" placeholder="하의" @change="parentChange('bottomType', bottomType)">
                                    <el-option
                                        v-for="item in BottomList"
                                        :key="`bottom${item.value}`"
                                        :label="item.name"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                                <div class="input_error" v-if="validation.hasError('pattern')">{{validation.firstError('pattern') }}</div>
                                <div class="input_error" v-else-if="validation.hasError('season')">{{validation.firstError('season') }}</div>
                                <div class="input_error" v-else-if="validation.hasError('color')">{{validation.firstError('color') }}</div>
                                <div class="input_error" v-else-if="validation.hasError('tone')">{{validation.firstError('tone') }}</div>
                                <div class="input_error" v-else-if="validation.hasError('gender')">{{validation.firstError('gender') }}</div>
                                <div class="input_error" v-else-if="validation.hasError('bottomType')">{{validation.firstError('bottomType') }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </el-collapse-transition>

    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import {PatternList, FitList, SeasonList, ColorList, ToneList, GenderList, BottomList} from "@/service/itemService"
import util from '@/mixins/util';
import treesetFunction from "@/components/item/lib/treesetFunction";
import EventBus from '../../../../mixins/event-bus';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    name: "ItemDisplayLayout",
    mixins: [treesetFunction],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            PatternList: PatternList,
            SeasonList: SeasonList,
            ColorList : ColorList,
            ToneList : ToneList,
            GenderList: GenderList,
            BottomList: BottomList,
            contentShow: true,
            validatorArr: ['category','selling', 'fitting', 'pattern', 'season', 'color', 'tone', 'gender', 'bottomType'],

            TotalCateList: [],

            display: 0,
            selling : 0, //판매상태
            fitting: 0,
            category: '', //상품 카테고리
            pattern: '', //패턴
            season: '', //시즌
            color: '', //컬러
            tone: '', //톤
            gender: '', //성별
            bottomType: '', //하의,
            brandData: {}, // 연결된 브랜드 정보
        }
    },
    created() {
        this.getCategory();
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ItemDisplayLayout')
        EventBus.$on('changeSellingStatus', res => {
            this.selling = res
        })
        EventBus.$on('changeBrandDataStatus', res => {
            this.brandData = res
        })
    },
    beforeDestroy() {
        EventBus.$off('changeSellingStatus')
        EventBus.$off('changeBrandDataStatus')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.display = this.itemData.display;
            this.category = this.itemData.category;
            this.pattern = this.itemData.pattern;
            this.season = this.itemData.season;
            this.color = this.itemData.color;
            this.tone = this.itemData.tone;
            this.gender = this.itemData.gender;
            this.bottomType = this.itemData.bottomType;
            this.selling = this.itemData.selling;
            this.fitting = this.itemData.fitting;
            this.brandData = this.itemData.brandData
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        getCategory() {
            this.$api.$item.getItemCategory().then(res => {
                this.TotalCateList = res.Data.Result.List;
                this.SelCateList[0] = this.TotalCateList;
                if(this.isItemData()) {
                    let ExItem = {};
                    this.TreeInfoExtra(this.TotalCateList, ExItem, {}, 0);
                    let cateWrap = ExItem[this.category];
                    let depth = cateWrap.depth;
                    for(let i = depth; i > 0 ; i--) {
                        this.SetSubCate(depth-i+1, cateWrap.ItemList[i-1]);
                    }
                }
                this.$forceUpdate();
            })
        },
        SetSubCate(index, item) {
            for(let i = index ; i < this.SelCateList.length ; i ++) {
                this.SelCateList[i] = [];
                this.cateValue[i] = [];
            }
            this.cateValue[index - 1] = item;
            if(item.hasOwnProperty('child')) {
                this.SelCateList[index] = item.child;
                this.category = '';
            }else{
                this.category = item.PKEY;
            }

            this.parentChange('category', this.category);
            this.$forceUpdate();
        },
        checkValidator() {
            this.$validate(['category', 'pattern', 'season', 'color', 'tone', 'gender', 'bottomType'])
        },
        checkBrandLink(){
            if(!util.isEmpty(this.brandData)){
                return false
            } else {
               return true
            }
        },
    },
    watch: {},
    validators: {
        selling: function (value) {
            return Validator.value(value)
        },
        fitting: function (value) {
            return Validator.value(value)
        },
        display: function (value) {
            return Validator.value(value)
        },
        category: function (value) {
            return Validator.value(value)
                .required('상품 카테고리를 선택해주세요.');
        },
        pattern: function (value) {
            return Validator.value(value)
                .required('상품 패턴을 선택해주세요.');
        },
        season: function (value) {
            return Validator.value(value)
                .required('상품 시즌을 선택해주세요.');
        },
        color: function (value) {
            return Validator.value(value)
                .required('상품 컬러를 선택해주세요.');
        },
        tone: function (value) {
            return Validator.value(value)
                .required('상품 톤을 선택해주세요.');
        },
        gender: function (value) {
            return Validator.value(value)
                .required('성별을 선택해주세요.');
        },
        bottomType: function (value) {
            return Validator.value(value)
                .required('하의를 선택해주세요.');
        },
    },
}
</script>

<style scoped>

</style>
